import * as React from 'react'
// libs
import styled from 'styled-components'
// components
import FinalStep from 'components/Modals/CreateSubPlanModal/SubPlanStepper/components/FinalStep'
import FirstStep from 'containers/PlanCreateForm'
import AuthorizationWarning from 'components/UI/Warnings/AuthorizationWarning'
import SecondStep from 'containers/SubPlan/components/ParentPlanObjectivesList'
import Stepper from 'components/Modals/CreateSubPlanModal/SubPlanStepper/components/Stepper'
import StepperButtons from 'components/Modals/CreateSubPlanModal/SubPlanStepper/components/StepperButtons'
import { Scrollbar as ScrollbarOrigin } from 'components/UI'
// context
import { SubPlanStepperAPIContext } from 'containers/SubPlan/layers/API'
import { SubPlanStepperBLContext } from 'containers/SubPlan/layers/BL/Stepper'
// constants
import { Forms } from 'constants/index'
// hooks
import { usePlanAccess } from 'hooks/index'

// styled
const Wrapper = styled('div')`
  height: calc(100% - 63px);
`

const Scrollbar = styled((props) => <ScrollbarOrigin {...props} />)<{ activeStep: number }>`
  display: flex;
  flex-direction: column;
  height: calc(100% - 56px);
  max-width: 960px;
  padding: ${({ activeStep }) => (activeStep === 1 ? '0 0 0 16px' : 0)};
  transition: width 0.5s ease-in-out;
  width: ${({ activeStep }) => (activeStep === 0 ? '600px' : 'calc(100vw - 414px)')};

  > div:first-child {
    padding: 16px 16px 0;
  }
`

const SubPlanStepper: React.FC = () => {
  const { createdPlan, parentPlan } = React.useContext(SubPlanStepperAPIContext)
  const { activeStep, handleFormSubmit, handleSetAnyTouched } = React.useContext(SubPlanStepperBLContext)

  const shouldShowPlan = usePlanAccess(parentPlan)

  return (
    <Wrapper>
      <Scrollbar activeStep={activeStep}>
        {activeStep < 2 && <Stepper />}
        {activeStep === 0 && (
          <FirstStep
            destroyOnUnmount={false}
            form={Forms.CREATE_SUB_PLAN_FORM}
            isSubPlanCreation
            onChange={() => handleSetAnyTouched(true)}
            onSubmit={handleFormSubmit(parentPlan)}
          />
        )}
        {activeStep === 1 && shouldShowPlan && (
          <SecondStep currentPlan={createdPlan} isSubPlanCreation parentPlan={parentPlan} />
        )}
        {activeStep === 1 && !shouldShowPlan && <AuthorizationWarning />}
        {activeStep === 2 && <FinalStep />}
      </Scrollbar>

      <StepperButtons />
    </Wrapper>
  )
}

export default SubPlanStepper
